'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhonelinkRing = function MdPhonelinkRing(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 33.4v-26.8h-16.8v26.8h16.8z m0-31.8c1.8 0 3.2 1.6 3.2 3.4v30c0 1.8-1.4 3.4-3.2 3.4h-16.8c-1.8 0-3.2-1.6-3.2-3.4v-30c0-1.8 1.4-3.4 3.2-3.4h16.8z m6.6 14.7c2 2.2 2 5.2 0 7.2l-1.6-1.7c0.8-1.2 0.8-2.7 0-3.8z m3.5-3.5c4.2 4 4.2 10.4 0 14.2l-1.7-1.7c3-3.2 3-7.8 0-10.8z' })
        )
    );
};

exports.default = MdPhonelinkRing;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/phonelink-ring.js
// module id = 2647
// module chunks = 0